import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

export default function CapturePasswordEntered(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    // updating the modal property
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "georgew")
    .update([ "password" ], "123456789012")
    .update([ "userIDValOnChange" ], "georgew")
    .update([ "passwordValOnChange" ], "123456789012")
    .submit();

    return <LoginPage data={ data } />
}
